<mat-card>
    <div class="mat-card-header">
        <h2>Technical Skills</h2>
    </div>
    <mat-card-content>
        <div class="skillTable">
            <div class="titles">
                <i class="fab fa-java iconStyle" aria-hidden="true"></i>
                <span class="skillTitle">Java</span>
            </div>
            <div>
                <span>Beginner</span>
                <mat-slider min="0" max="100" step="5" value="90" thumbLabel style="pointer-events: none;"
                    [displayWith]="formatLabel"></mat-slider>
                <span>Expert</span>
            </div>

        </div>

    </mat-card-content>
    <mat-card-content>
        <div class="skillTable">
            <div class="titles">
                <i class="fab fa-python iconStyle" aria-hidden="true"></i>
                <span class="skillTitle">Python</span>
            </div>
            <div>
                <span>Beginner</span>
                <mat-slider min="0" max="100" step="5" value="50" thumbLabel style="pointer-events: none;"
                    [displayWith]="formatLabel"></mat-slider>
                <span>Expert</span>
            </div>

        </div>

    </mat-card-content>
    <mat-card-content>
        <div class="skillTable">
            <div class="titles">
                <i class="fab fa-html5 iconStyle" aria-hidden="true"></i>
                <i class="fab fa-css3-alt iconStyle" aria-hidden="true"></i>
                <span class="skillTitle">HTML & CSS</span>
            </div>
            <div>
                <span>Beginner</span>
                <mat-slider min="0" max="100" step="5" value="75" thumbLabel style="pointer-events: none;"
                    [displayWith]="formatLabel"></mat-slider>
                <span>Expert</span>
            </div>

        </div>

    </mat-card-content>
    <mat-card-content>
        <div class="skillTable">
            <div class="titles">
                <i class="fab fa-js-square iconStyle" aria-hidden="true"></i>
                <span class="skillTitle">JS & TypeScript</span>
            </div>
            <div>
                <span>Beginner</span>
                <mat-slider min="0" max="100" step="5" value="70" thumbLabel style="pointer-events: none;"
                    [displayWith]="formatLabel"></mat-slider>
                <span>Expert</span>
            </div>

        </div>

    </mat-card-content>
    <mat-card-content>
        <div class="skillTable">
            <div class="titles">
                <i class="fas fa-database iconStyle" aria-hidden="true"></i>
                <span class="skillTitle">SQL</span>
            </div>
            <div>
                <span>Beginner</span>
                <mat-slider min="0" max="100" step="5" value="80" thumbLabel style="pointer-events: none;"
                    [displayWith]="formatLabel"></mat-slider>
                <span>Expert</span>
            </div>

        </div>

    </mat-card-content>
    <mat-card-content>
        <div class="skillTable">
            <div class="titles">
                <i class="fas fa-terminal iconStyle" aria-hidden="true"></i>
                <span class="skillTitle">Shell Scripting</span>
            </div>
            <div>
                <span>Beginner</span>
                <mat-slider min="0" max="100" step="5" value="45" thumbLabel style="pointer-events: none;"
                    [displayWith]="formatLabel"></mat-slider>
                <span>Expert</span>
            </div>

        </div>

    </mat-card-content>
    <mat-card-content>
        <div class="skillTable">
            <div class="titles">
                <i class="fab fa-git-square iconStyle" aria-hidden="true"></i>
                <span class="skillTitle">Git VCS</span>
            </div>
            <div>
                <span>Beginner</span>
                <mat-slider min="0" max="100" step="5" value="60" thumbLabel style="pointer-events: none;"
                    [displayWith]="formatLabel"></mat-slider>
                <span>Expert</span>
            </div>

        </div>

    </mat-card-content>
    <mat-card-content>
        <div class="skillTable">
            <div class="titles">
                <i class="fab fa-docker iconStyle" aria-hidden="true"></i>
                <span class="skillTitle">Docker</span>
            </div>
            <div>
                <span>Beginner</span>
                <mat-slider min="0" max="100" step="5" value="50" thumbLabel style="pointer-events: none;"
                    [displayWith]="formatLabel"></mat-slider>
                <span>Expert</span>
            </div>

        </div>

    </mat-card-content>
</mat-card>